import React from 'react'

export default function Play({ height, width }: { height: number, width: number }) {
    return (
        <svg height={height} role="img" width={width} viewBox="0 0 24 24">
            <polygon points="21.57 12 5.98 3 5.98 21 21.57 12" fill="currentColor"></polygon>
        </svg>
    )
}